/** @format */

export const commonPrivatePersonBasicInfoServiceModule = 'sis-components.service.privatePersonBasicInfoService';

(function () {
    privatePersonBasicInfoService.$inject = ['privatePersonBasicInfoJSDataModel', '$http'];
    angular
        .module(commonPrivatePersonBasicInfoServiceModule, ['sis-components.model.privatePersonBasicInfo'])
        .factory('commonPrivatePersonBasicInfoService', privatePersonBasicInfoService);

    function privatePersonBasicInfoService(privatePersonBasicInfoJSDataModel, $http) {
        var personDataChangeBaseUrl = '/ori/api/persons/';

        return {
            findPersonBasicInfoById: function (personId, bypassCache) {
                var options = {
                    bypassCache: !!bypassCache,
                };
                return privatePersonBasicInfoJSDataModel.find(personId, options);
            },
        };
    }
})();
